/**
 * Robert Penner's "ease in/out circular" easing function, ported from the
 * `js-easing-functions` package (the only easing we used from it).
 *
 * @param elapsed        Time elapsed since the start of the animation.
 * @param initialValue   Starting value.
 * @param amountOfChange Total change in value over the duration.
 * @param duration       Total duration of the animation.
 * @returns The eased value at `elapsed`.
 */
export function easeInOutCirc(
  elapsed: number,
  initialValue: number,
  amountOfChange: number,
  duration: number
): number {
  if ((elapsed /= duration / 2) < 1) {
    return (-amountOfChange / 2) * (Math.sqrt(1 - elapsed * elapsed) - 1) + initialValue;
  }
  return (amountOfChange / 2) * (Math.sqrt(1 - (elapsed -= 2) * elapsed) + 1) + initialValue;
}
